const styles = {
    container: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        gap: '24px',
        textAlign: 'center',
        color: 'white',
        overflow: 'hidden',
    },
    header: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
    },
    iconWrapper: {
        position: 'relative',
    },
    iconGlow: {
        position: 'absolute',
        inset: '-15px',
        background: '#a855f7',
        filter: 'blur(30px)',
        opacity: 0.3,
        borderRadius: '50%',
    },
    icon: {
        fontSize: '64px',
        position: 'relative',
        zIndex: 1,
    },
    title: {
        fontSize: '36px',
        fontWeight: 800,
        letterSpacing: '-2px',
        background: 'linear-gradient(90deg, #ffffff, #d8b4fe)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        margin: 0,
    },
    subtitle: {
        color: '#94a3b8',
        fontSize: '14px',
        maxWidth: '260px',
        margin: 0,
    },
    featuresGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '12px',
        width: '100%',
        maxWidth: '280px',
    },
    featureCard: {
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        padding: '12px',
        borderRadius: '12px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
    },
    featureIcon: {
        fontSize: '20px',
        marginBottom: '4px',
    },
    featureLabel: {
        fontSize: '11px',
        color: '#94a3b8',
    },
    featureValue: {
        fontWeight: 700,
        fontSize: '14px',
    },
    timeBonusIcon: {
        color: '#fbbf24',
        fontWeight: 700,
        fontSize: '16px',
        marginBottom: '4px',
    },
    startButton: {
        width: '100%',
        maxWidth: '280px',
        padding: '14px 20px',
        backgroundColor: 'white',
        color: '#1e293b',
        border: 'none',
        borderRadius: '14px',
        fontSize: '18px',
        fontWeight: 700,
        cursor: 'pointer',
        boxShadow: '0 0 30px rgba(255, 255, 255, 0.3)',
        transition: 'all 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
    },
    playIcon: {
        fontSize: '18px',
    },
};

export const MainMenu = ({ onStart }) => {
    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <div style={styles.iconWrapper}>
                    <div style={styles.iconGlow}></div>
                    <span style={styles.icon}>🧮</span>
                </div>
                <h1 style={styles.title}>Addem Numbers</h1>
                <p style={styles.subtitle}>
                    Race against time. Solve fast. Scale up.
                </p>
            </div>

            <div style={styles.featuresGrid}>
                <div style={styles.featureCard}>
                    <div style={styles.featureIcon}>🧠</div>
                    <div style={styles.featureLabel}>Dynamic Difficulty</div>
                    <div style={styles.featureValue}>+Range</div>
                </div>
                <div style={styles.featureCard}>
                    <div style={styles.timeBonusIcon}>+2s</div>
                    <div style={styles.featureLabel}>Time Bonus</div>
                    <div style={styles.featureValue}>Correct</div>
                </div>
            </div>

            <button
                onClick={onStart}
                style={styles.startButton}
                onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 0 40px rgba(255, 255, 255, 0.5)';
                }}
                onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 0 30px rgba(255, 255, 255, 0.3)';
                }}
            >
                <span>Start Game</span>
                <span style={styles.playIcon}>▶</span>
            </button>
        </div>
    );
};
